<template>
  <div class="whole">
    <div class="search" :inline="true" style="margin-bottom: 20px">
      <!--  搜索框      -->
      <el-input
          @keyup.enter.native="searchClick(inputUser)"
          :placeholder="$t('placeholder.Search')"
          prefix-icon="el-icon-search"
          style="width: 400px;margin-right: 10px;margin-left: 10px;"
          v-model="inputUser">
      </el-input>
      <el-button type="primary" icon="el-icon-search" @click="searchClick(inputUser)">{{
          $t("button.Search")
        }}
      </el-button>
    </div>

    <div class="table">
      <el-table
          :data="userData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
          :header-cell-style="{'text-align':'center'}"
          :cell-style="{'text-align':'center'}"
          border
          style="width: 100%">
        <el-table-column
            prop="username"
            :label="$t('label.Username')">
        </el-table-column>
        <el-table-column
            prop="organization"
            :label="$t('label.Organization')">
        </el-table-column>
        <el-table-column
            prop="cityName"
            :label="$t('label.City')">
        </el-table-column>
        <el-table-column
            prop="phone_number"
            :label="$t('label.PhoneNumber')">
        </el-table-column>
        <el-table-column
            prop="email"
            :label="$t('label.Email')">
        </el-table-column>
        <el-table-column :label="$t('label.Opening Account')" width="150px">
          <template v-slot="scope">
            <el-switch
                v-model="scope.row.enabled"
                :active-text="$t('label.Open')"
                :inactive-text="$t('label.Close')"
                :active-value=1
                :inactive-value=0
                @change="changeUser(scope.row)">
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="roles" :label="$t('label.Roles')">
          <template v-slot="scope">
            <!--    1、中文的时候--- isLanguage       -->
            <el-select v-if="isLanguage" v-model="scope.row.roles" multiple collapse-tags filterable
                       v-show="scope.row.iseditor">
              <el-option
                  v-for="item in rolesOption"
                  :key="item.roleId"
                  :label="item.roleNameCn"
                  :value="item.roleId">
              </el-option>
            </el-select>
            <el-select v-if="isLanguage" v-model="scope.row.roles" multiple filterable disabled
                       v-show="!scope.row.iseditor">
              <el-option
                  v-for="item in rolesOption"
                  :key="item.roleId"
                  :label="item.roleNameCn"
                  :value="item.roleId">
              </el-option>
            </el-select>

            <!--    2、!英文的时候--- isLanguage       -->
            <el-select v-if="!isLanguage" v-model="scope.row.roles" multiple collapse-tags filterable
                       v-show="scope.row.iseditor">
              <el-option
                  v-for="item in rolesOption"
                  :key="item.roleId"
                  :label="item.roleNameEn"
                  :value="item.roleId">
              </el-option>
            </el-select>

            <el-select v-if="!isLanguage" v-model="scope.row.roles" multiple filterable disabled
                       v-show="!scope.row.iseditor">
              <el-option
                  v-for="item in rolesOption"
                  :key="item.roleId"
                  :label="item.roleNameEn"
                  :value="item.roleId">
              </el-option>
            </el-select>

          </template>
        </el-table-column>

        <el-table-column :label="$t('label.Operation')">
          <template v-slot="scope">
            <el-button class="el-icon-edit" @click="perModify(scope.row)" type="text" size="small">{{
                $t("button.Edit")
              }}
            </el-button>
            <el-button class="el-icon-check" @click="save(scope.row)" type="text" size="small">{{
                $t("button.Save")
              }}
            </el-button>
          </template>
        </el-table-column>

      </el-table>

    </div>

    <div class="pagination">
      <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pagesize"
          @current-change="current_change"
          :total="userData.length">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "userChange",
  data() {
    return {
      isLanguage: '',
      inputUser: '',
      pagesize: 5,//每页的数据条数
      currentPage: 1,//默认开始页面
      userData: [],
      userList: [],
      confirmButtonText: '',
      cancelButtonText: '',
      confirmMessage: '',
      title: '',
      rolesOption: [{
        roleId: 1,
        roleNameCn: "管理员",
        roleNameEn: "Administrators"
      },
        {
          roleId: 2,
          roleNameCn: "数据录入员",
          roleNameEn: "Data entry personnel"
        },
        {
          roleId: 3,
          roleNameCn: "数据审核员",
          roleNameEn: "Data Audit personnel"
        },
        {
          roleId: 4,
          roleNameCn: "数据维护员",
          roleNameEn: "Data Maintain personnel"
        },
        {
          roleId: 5,
          roleNameCn: "正式会员",
          roleNameEn: "Full Member"
        },
        {
          roleId: 6,
          roleNameCn: "2006年度会员",
          roleNameEn: "Member of 2006"
        },
        {
          roleId: 7,
          roleNameCn: "2007年度会员",
          roleNameEn: "Member of 2007"
        },
        {
          roleId: 8,
          roleNameCn: "2008年度会员",
          roleNameEn: "Member of 2008"
        },
        {
          roleId: 9,
          roleNameCn: "2009年度会员",
          roleNameEn: "Member of 2009"
        },
        {
          roleId: 10,
          roleNameCn: "2010年度会员",
          roleNameEn: "Member of 2010"
        },
        {
          roleId: 11,
          roleNameCn: "2011年度会员",
          roleNameEn: "Member of 2019"
        },
        {
          roleId: 12,
          roleNameCn: "2012年度会员",
          roleNameEn: "Member of 2012"
        },
        {
          roleId: 13,
          roleNameCn: "2013年度会员",
          roleNameEn: "Member of 2013"
        },
        {
          roleId: 14,
          roleNameCn: "2014年度会员",
          roleNameEn: "Member of 2014"
        },
        {
          roleId: 15,
          roleNameCn: "2015年度会员",
          roleNameEn: "Member of 2015"
        },
        {
          roleId: 16,
          roleNameCn: "2016年度会员",
          roleNameEn: "Member of 2016"
        },
        {
          roleId: 17,
          roleNameCn: "2017年度会员",
          roleNameEn: "Member of 2017"
        },
        {
          roleId: 18,
          roleNameCn: "2018年度会员",
          roleNameEn: "Member of 2018"
        },
        {
          roleId: 19,
          roleNameCn: "2019年度会员",
          roleNameEn: "Member of 2019"
        },
        {
          roleId: 20,
          roleNameCn: "2020年度会员",
          roleNameEn: "Member of 2020"
        },
        // {
        //   roleId:21,
        //   roleNameCn:"2021年度会员",
        //   roleNameEn:"Member of 2021"
        // },
        // {
        //   roleId:22,
        //   roleNameCn:"2022年度会员",
        //   roleNameEn:"Member of 2022"
        // },
        // {
        //   roleId:23,
        //   roleNameCn:"2023年度会员",
        //   roleNameEn:"Member of 2023"
        // },
        // {
        //   roleId:24,
        //   roleNameCn:"2024年度会员",
        //   roleNameEn:"Member of 2024"
        // },
        // {
        //   roleId:25,
        //   roleNameCn:"2025年度会员",
        //   roleNameEn:"Member of 2025"
        // },
        // {
        //   roleId:26,
        //   roleNameCn:"2026年度会员",
        //   roleNameEn:"Member of 2026"
        // },
        // {
        //   roleId:27,
        //   roleNameCn:"2027年度会员",
        //   roleNameEn:"Member of 2027"
        // }
      ]
    }
  },
  methods: {
    changeUser: function (row) {
      request.put('/sysUser', row).then(successResponse => {
        console.log(successResponse)
      })
    },
    //监测当前页面
    current_change: function (currentPage) {
      this.currentPage = currentPage;
    },
    getAllUser() {
      var that = this
      var userDict = {}
      var tempData = {}
      var tempRole = []
      request.get('/sysUser').then(function (res) {
        tempData = res.data
        tempData.forEach(function (e) {
              userDict = {}
              tempRole = []
              userDict.iseditor = false
              userDict.id = e.id
              userDict.organization = e.organization
              if (that.$i18n.locale === 'cn') {
                userDict.cityName = e.user_city.name_cn
              } else {
                userDict.cityName = e.user_city.name_en
              }
              userDict.phone_number = e.phone_number
              userDict.username = e.username
              userDict.email = e.email
              userDict.enabled = e.enabled
              e.roles.forEach(function (ro) {
                tempRole.push(ro.id)
              })
              userDict.roles = tempRole
              that.userData.push(userDict)
            },
            that.userList = that.userData
        )
      }).catch(function (err) {
        console.log(err)
      })
    },
    perModify(row) {
      if (row.enabled === 0) {
        if (this.$i18n.locale === 'cn') {
          alert("请先开通账户，再选择权限！")
        } else {
          alert("Please open the account first, and then select permission!")
        }
      } else {
        row.iseditor = true
      }
    },
    //保存修改后的数据信息，上传至数据库
    save(row) {
      this.$forceUpdate()
      row.iseditor = false;
      if (this.$i18n.locale === 'cn') {
        this.confirmButtonText = '确定'
        this.cancelButtonText = '取消'
        this.confirmMessage = '此操作将修改该用户权限'
        this.title = '提示'
      } else {
        this.confirmButtonText = 'Confirm'
        this.cancelButtonText = 'Cancel'
        this.confirmMessage = 'This operation will modify the user permissions'
        this.title = 'tip'
      }
      this.$confirm(this.confirmMessage, this.title, {
        confirmButtonText: this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
        type: 'warning'
      }).then(() => {
        //处理一下更改的roles，再提交！
        var roleList = []
        var roleDic = {}
        for (let r = 0; r < row.roles.length; r++) {
          roleDic = {id: ''}
          roleDic.id = row.roles[r]
          roleList.push(roleDic)
        }
        row.roles = roleList
        request.put('/sysUser', row).then(successResponse => {
          if (successResponse.data === true) {
            if (this.$i18n.locale === 'cn') {
              alert("数据信息修改成功！")
            } else {
              alert("Data information modified successfully!")
            }
            location.reload()
          } else {
            if (this.$i18n.locale === 'cn') {
              alert("数据信息修改失败！")
            } else {
              alert("Data information modified failed!")
            }
          }
        }).catch(err => {
          alert(err);
          console.log(err);
        })
      })
    },
    //在搜索框中输入val,进行查找，并将满足条件的元素，返回值user item
    searchName(val) {
      return this.userList.filter(item => {
        if (item.username.includes(val)) {
          return item
        }
      })
    },
    //实现搜索按钮
    searchClick(val) {
      if (val === '') {
        this.userData = this.userList
      } else {
        this.userData = this.searchName(val)
      }
    }
  },
  created() {
    this.getAllUser()
    if (this.$i18n.locale === 'cn') {
      this.isLanguage = true
    } else {
      this.isLanguage = false
    }
  }
}
</script>

<style scoped>
@import "~@/assets/css/sameCss.css";
</style>